/**
 * Predicate for whether an accent ID should produce a render / preload.
 *
 * Two no-render sentinels exist: `'blank'` (modern, used by `themeAccents.ts`)
 * and `'none'` (legacy default in `WebsiteDesigner.constants.ts`). Both must
 * suppress rendering and preload — pointing at `accent_blank@2x.png` or
 * `accent_none@2x.png` would 404.
 *
 * Lives in `@shared/utils` (rather than `layout-engine`) so callers in light
 * code paths (e.g. `GuestSiteHead`) don't drag in the layout-engine module
 * graph just to evaluate a one-line predicate.
 */
export const shouldRenderGraphicAccent = (accent: Maybe<string>): boolean => {
  return !!accent && accent !== 'blank' && accent !== 'none';
};
